/* istanbul ignore file */
export enum EventCostAllocation {
  EnhancedActivities = "enhancedActivities",
  Bar = "bar",
  FineDining = "fineDining"
}
